import { Component, Input, OnInit } from '@angular/core';
import { BaseComponent } from '@shared/components/base.component';
import { HeaderService } from '@shared/services/header.service';

@Component({
  selector: 'app-footer-link-columns',
  templateUrl: './footer-link-columns.component.html',
  styleUrls: ['./footer-link-columns.component.scss'],
})
export class FooterLinkColumnsComponent extends BaseComponent implements OnInit {
  @Input() label: string = '';
  @Input() links: string[] = [];
  @Input() eventCategory;
  type: string = null;

  displayPressModal: boolean = false;
  displayContactModal: boolean = false;

  constructor(public header: HeaderService) {
    super();
  }

  ngOnInit() {
    if (this.header.previousUrl.includes('/helpukraine')) {
      this.header.eventCategory = true;
    }
  }

  mailMe(item: string) {
    return 'mailto:' + item;
  }

  openModal(type: string) {
    switch (type) {
      case 'email-send':
        this.displayContactModal = true;
        break;
      case 'press-email-send':
        this.displayPressModal = true;
        break;
    }
  }

  isActive(page: string) {
    return this.router.url.search(page) > 0;
  }
}
